import { render } from "./DataBlock.vue?vue&type=template&id=668fb1bd&scoped=true"
import script from "./DataBlock.vue?vue&type=script&lang=js"
export * from "./DataBlock.vue?vue&type=script&lang=js"

import "./DataBlock.vue?vue&type=style&index=0&id=668fb1bd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668fb1bd"]])

export default __exports__